import { render, staticRenderFns } from "./PinMessageItem.vue?vue&type=template&id=332a0948"
import script from "./PinMessageItem.vue?vue&type=script&lang=js"
export * from "./PinMessageItem.vue?vue&type=script&lang=js"
import style0 from "./PinMessageItem.vue?vue&type=style&index=0&id=332a0948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports